const slider_config_type = {
    1: {
            slidesPerView: 4.225,
            spaceBetween: 20,
            breakpoints: {
                1: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                300: {
                    slidesPerView: 1.35,
                    spaceBetween: 16,
                
                },
                400: {
                    slidesPerView: 1.5,
                    spaceBetween: 16,
                
                },
                640: {
                    slidesPerView: 2.2,
                
                    
                },
                850: {
                    slidesPerView: 3.2,
                
                },
                1300: {
                    slidesPerView: 4.225,
                    spaceBetween: 20,
                }
            }
        },
    2: {
            slidesPerView: 3,
            spaceBetween: 20,
            breakpoints: {
                1: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                300: {
                    slidesPerView: 1.2,
                    spaceBetween: 10,
                
                },
                400: {
                    slidesPerView: 1.3,
                    spaceBetween: 10,
                
                },
                640: {
                    slidesPerView: 2.2,
                
                    
                },
                850: {
                    slidesPerView: 3,
                
                },
                1300: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                }
            }
        },
    3:  {
            slidesPerView: 1,
            spaceBetween: 20,
            pagination: {
                el: ".swiper-pagination",
                type: "progressbar",
            },
        },
    4:  {
            slidesPerView: 1,
            spaceBetween: 0,
            autoHeight: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        },
    5: {
            slidesPerView: 4,
            spaceBetween: 20,
            breakpoints: {
                1: {
                    slidesPerView: 1.3,
                    spaceBetween: 10,
                },
                767: {
                    slidesPerView: 2,
                
                    
                },
                850: {
                    slidesPerView: 3,
                
                },
                1300: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                }
            }
        },
    6: {
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
        },
    },
    7: {
        slidesPerView: 4,
        spaceBetween: 10,
        freeMode: true,
        watchSlidesProgress: true,
    },
    8: {
        slidesPerView: 'auto',
        spaceBetween:20,
        initialSlide: 1,
        speed: 700,
        slidesOffsetAfter:50,
        breakpoints: {
            1: {
                centeredSlides: false,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                spaceBetween: 10,
            },
            767: {
                slidesOffsetBefore:0,
                slidesOffsetAfter:50
            }
        }
      
    },
    9: {
        slidesPerView: 'auto',
        initialSlide: 1,
        breakpoints: {
            1: {
                initialSlide: 0,
                slidesOffsetBefore: 20,
                slidesOffsetAfter: 20,
                spaceBetween: 40
            },
            767: {
                initialSlide: 1,
            }
        }
    },
    10: {
        slidesPerView: 6,
        spaceBetween:20,
        breakpoints: {
            1: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            300: {
                slidesPerView: 2.9,
                spaceBetween: 10,
            },
            767: {
                slidesPerView: 3,
                
            },
            850: {
                slidesPerView: 3,
            
            },
            1023: {
                slidesPerView: 5,
                spaceBetween: 20,
            },
            1600: {
                slidesPerView: 6,
                spaceBetween: 20,
            }
        }
    }
}


class CustomSlider extends HTMLElement {
    connectedCallback() {
        this.index = this.dataset.index || 1;
        this.navigation = {
            navigation: {
                nextEl: this.index != 7 ? this.closest('.shopify-section').querySelector(".swiper-button-next") : null,
                prevEl: this.index != 7 ? this.closest('.shopify-section').querySelector(".swiper-button-prev") : null,
            },
        }
        this.config = {...slider_config_type[this.index], ...this.navigation};
        this.swiper = new Swiper(this, this.config);
        this.swiper.on('slideChange', this.changeHandler.bind(this));
        this.swiper.on('slideChangeTransitionStart', this.setPadding.bind(this));
        
        this.ThumbActive();
    }
    setPadding() {
        if(this.index != 8) return
        this.swiper.activeIndex == 0 ?
        this.style.setProperty('--padding-left', 5 + '%')
        :this.style.setProperty('--padding-left', 42 + '%');
    }
    ThumbActive() {
        if (this.dataset.index != "6") return
        const thumbSliderEl = document.querySelector('custom-slider.swiper-thumb');
        this.checkThumb(thumbSliderEl);
    }
    checkThumb(thumbSlider) {
         const thumbSwiper = thumbSlider?.swiper;
         
        if (thumbSwiper) {
            this.swiper.thumbs.swiper = thumbSwiper;
            this.swiper.thumbs.init();
            this.swiper.thumbs.update();
        } else {
            setTimeout(() => this.checkThumb(thumbSlider), 100);
        }
    }
    changeHandler() {
        const activeSlideEl = this.swiper.slides[this.swiper.activeIndex];
        const colorDots = activeSlideEl.getAttribute('color-dots');
        const colorActiveDots = activeSlideEl.getAttribute('color-active-dots');
        const paginationNumeric = this.closest('div').querySelector('.custom-number p');
        if( colorDots && colorActiveDots) this.changeColorPagination(colorDots, colorActiveDots);
        if(paginationNumeric) this.changePaginationText(paginationNumeric);
    }
    changeColorPagination(color, colorActive) {
        this.querySelector('.swiper-pagination').style.setProperty('--element-color-dots', color);
        this.querySelector('.swiper-pagination').style.setProperty('--element-color-dots-active', colorActive);
    }
    changePaginationText(el) {
        const index = this.swiper.activeIndex + 1;
        const count = this.swiper.slides.length;
        el.innerText = `${index} / ${count}`;
    }
}

customElements.define('custom-slider', CustomSlider);